module.exports = __webpack_public_path__ + "static/media/logo.d1c78633.svg";